var Selector = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.selectorType = this.options.$el.data("type");
  this.$bgDots = this.options.$el.find(".bg-dots");

};

/**
 * Gallery
 * @return {[type]} [description]
 */
Selector.prototype.init = function(){

  var self = this;

  if(this.selectorType == "animated"){
    self.initAnimatedGallery();
  }

  //
  // Adjust BG dots filigree layer
  //
  var offsetLeft = this.options.$el.find(".selector-rows-container").offset().left;
  this.$bgDots.width(offsetLeft - 40);

};

/**
 * Init our animated gallery
 * @return {[type]} [description]
 */
Selector.prototype.initAnimatedGallery = function(){

  var self = this;

  this.$gallery = this.options.$el.find("[data-selector-image-gallery]");

  // when the user mouses over a row
  this.options.$el.find(".first-selector-rows-group [data-selector-row]").on("mouseenter", function(){

    var index = $(this).data("index");
    self.$gallery.trigger("gotoSlide", {index: index});

    var breakpoint = window.Breakpoint.value;

    if (breakpoint == 'xsmall')
    {
      // on small screens we scroll down so they can see the effect of clicking

      var scrollTop = self.$gallery.offset().top - 20;

      $([document.documentElement, document.body]).animate({
        scrollTop: scrollTop
      }, 1000);

    }

  });

};

export default  Selector;
